import React from 'react';
import PropTypes from 'prop-types';
import Snackbar from 'base/components/Snackbar';

const SuccessfulEditSnackbar = ({ open, item, onClose }) => {
  const getMessage = item => (
    <span>
      <strong>{item}</strong> was updated in your cart!
    </span>
  );

  return <Snackbar onClose={onClose} open={open} message={getMessage(item)} />;
};

SuccessfulEditSnackbar.defaultProps = {
  open: false,
  onClose: () => {}
};

SuccessfulEditSnackbar.propTypes = {
  item: PropTypes.string.isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func
};

export default SuccessfulEditSnackbar;
